import { render } from "./ClientsPanel.vue?vue&type=template&id=77c94b39&scoped=true"
import script from "./ClientsPanel.vue?vue&type=script&lang=js"
export * from "./ClientsPanel.vue?vue&type=script&lang=js"

import "./ClientsPanel.vue?vue&type=style&index=0&id=77c94b39&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c94b39"]])

export default __exports__